import { createClient } from '@supabase/supabase-js'
import { supabaseShowTimesInit } from './Methods/showTimes';
import { supabaseMoviesInit } from './Methods/movies';
import { supabaseNewsletterInit } from './Methods/newsletter';
import { supabaseChangelogInit } from './Methods/changelog';

const REACT_APP_SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const REACT_APP_SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create a single supabase client for interacting with your database

const supabase = createClient(REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY)


export const supabaseShowTimes = supabaseShowTimesInit(supabase)
export const supabaseMovies = supabaseMoviesInit(supabase);
export const supabaseNewsletter = supabaseNewsletterInit(supabase);
export const supabaseChangelog = supabaseChangelogInit(supabase);
export default supabase; // raw client (read-only use in public pages)
